











import StatisticsCardRow from "@/components/utility/StatisticsCardRow.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { Component } from "vue-property-decorator";
import DocumentTable from "./DocumentTable.vue";
import SignRequestTable from "./SignRequestTable.vue";

@Component({
  components: {
    TheLayoutPortal,
    StatisticsCardRow,
    DocumentTable,
    SignRequestTable
  }
})
export default class SignRequestTableView extends PartnerFallbackMixin {
  loading = false;

  async mounted() {
    try {
      this.loading = true;
      await this.trySetByRouteOrDefault();
    } catch (e) {
      this.$toast.error((e as any).message);
      this.$log.error(e);
    } finally {
      this.loading = false;
    }
  }
}
